<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <v-dialog
              ref="dialogStart"
              v-model="modalStart"
              lazy
              full-width
              width="290px"
              :return-value.sync="dates.startDate"
            >
              <v-text-field
                slot="activator"
                :label="$t('message.startDate')"
                v-model="dates.startDate"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="dates.startDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn outline color="error" @click="modal = false">Cancel</v-btn>
                <v-btn outline color="primary" @click="$refs.dialogStart.save(dates.startDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="dialogFinal"
              v-model="modalEnd"
              lazy
              full-width
              width="290px"
              :return-value.sync="dates.finalDate"
            >
              <v-text-field
                slot="activator"
                :label="$t('message.endDate')"
                v-model="dates.finalDate"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="dates.finalDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn outline color="error" @click="modal = false">cancel</v-btn>
                <v-btn outline color="primary" @click="$refs.dialogFinal.save(dates.finalDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :loading="loading"
              @click="getReports"
              outline
            >{{ $t('message.filter') }}</v-btn>

            <vue-excel-xlsx
              :data="updatedReports"
              :columns="columns"
              :filename="'reportes'"
              :sheetname="'reporte'"
            >
              <v-btn :disabled="!updatedReports" color="error" outline>{{ $t('message.export') }}</v-btn>
            </vue-excel-xlsx>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items.sync="updatedReports"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                <span>{{ $t(`message.${props.header.text}`) }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.store.name }}</td>
              <td>{{ props.item.fullName }}</td>
              <td>{{ props.item.note }}</td>
              <td>{{ formatCurrency(props.item.delivery_price) }}</td>
              <td>{{ props.item.created_at }}</td>
              <td>{{ props.item.updated_at }}</td>
            </template>
          </v-data-table>
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { userRoles, purchaseStatus } from "../../../constants/constants";
import { GET_REPORTS_BY_DATE } from "../../../store/modules/shoppings/actions.type";

const firstDayOfMonth = moment()
  .startOf("month")
  .format("YYYY-MM-DD");
const currentDayOfMonth = moment().format("YYYY-MM-DD");

export default {
  name: "reportList",
  data() {
    return {
      updatedReports: [],
      modalStart: false,
      modalEnd: false,
      loading: false,
      columns: [
        {
          label: "Codigo",
          field: "code"
        },
        {
          label: "Nombre de la tienda",
          field: "storeName"
        },
        {
          label: "Cliente",
          field: "fullName"
        },
        {
          label: "Metodo de pago",
          field: "note"
        },
        {
          label: "Costo del envio",
          field: "delivery_price"
          //dataFormat: this.formatCurrency
        },
        {
          label: "Fecha de compra",
          field: "created_at"
        },
        {
          label: "Fecha de entrega",
          field: "updated_at"
        }
      ],
      headers: [
        { text: "code", align: "center", sortable: true, value: "code" },
        {
          text: "storeName",
          align: "center",
          sortable: false,
          value: ""
        },
        { text: "client", align: "center", sortable: true, value: "client" },

        {
          text: "paymentMethod",
          align: "center",
          sortable: false,
          value: "note"
        },
        {
          text: "deliveryCost",
          align: "center",
          sortable: false,
          value: ""
        },
        {
          text: "purchaseDate",
          align: "center",
          sortable: true,
          value: "created_at"
        },
        {
          text: "deliveryDate",
          align: "center",
          sortable: true,
          value: "updated_at"
        }
      ],
      pagination: {
        descending: true,
        sortBy: "updated_at",
        rowsPerPage: 10
      },
      dates: {
        startDate: firstDayOfMonth,
        finalDate: currentDayOfMonth
      }
    };
  },
  computed: {
    ...mapGetters(["reports"])
  },
  created() {
    this.getReports();
  },
  methods: {
    async getReports() {
      this.loading = true;
      await this.$store.dispatch(GET_REPORTS_BY_DATE, this.dates);
      await this.updateReports();
      this.loading = false;
    },
    fullName(item) {
      const { name, lastname } = item.client;

      return name + " " + (lastname == "Not set" ? "" : lastname);
    },
    formatCurrency(currency) {
      if (currency) {
        return currency + " $";
      }

      return 0;
    },
    updateReports() {
      this.reports.forEach(report => {
        report.fullName = this.fullName(report);
        report.storeName = report.store.name;
      });

      this.updatedReports = this.reports;
    }
  }
};
</script>

<style scoped>
td {
  text-align: center;
}
</style>
